function IconBxsDownArrow(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={props.fill}
      height={props.height}
      width={props.width}
      {...props}
    >
      <path d="M11.178 19.569a.998.998 0 001.644 0l9-13A.999.999 0 0021 5H3a1.002 1.002 0 00-.822 1.569l9 13z" />
    </svg>
  );
}

IconBxsDownArrow.defaultProps = {
  fill: 'currentColor',
  height: '1em',
  width: '1em',
}

export default IconBxsDownArrow;
